import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import SelectRow from "../../components/Select/SelectRow";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import Constants from "../../core/Constants";

export default class BannerAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      version: 0,
      title: "",
      merchantlist: [],
      merchantId: "",
      branchlist: [],
      branchId: "",
      description: "",
      currentMediaUrl: "",
      removeMedia: false,
      loading: false,
      photos: [],
      photosLoading: false,
      uploadingPhoto: false,
    };
    this.pathname = "Banners";
    this.engine = new RequestEngine();
    this.bannerFileRef = React.createRef();
    this.photoFileRef = React.createRef();
    this.selectedBannerFile = null;
    this.previewUrl = null;
  }

  componentDidMount() {
    const edit = this.props.location.data;
    if (edit) {
      this.setState(
        {
          id: edit.id,
          version: edit.version,
          title: edit.title,
          description: edit.description,
          currentMediaUrl: edit.mediaUrl || "",
        },
        () => {
          if (edit.id) this.fetchPhotos(edit.id);
        }
      );
    }
    this.prepareData();
  }

  async prepareData() {
    const responseuni = await this.engine.getItemlistDirect("merchants");
    if (responseuni) {
      const merchantlist = responseuni.data.items.map((p) => ({
        value: p.id,
        label: p.name,
      }));
      this.setState({ merchantlist });
    }
  }

  async fetchBranches(merchantId) {
    const responseuni = await this.engine.getItemlistDirect(
      `merchants/${merchantId}/branches`
    );
    if (responseuni) {
      const branchlist = responseuni.data.items.map((p) => ({
        value: p.id,
        label: p.name || p.address || (p.area && p.area.name) || "-",
      }));
      this.setState({ branchlist });
    }
  }

  async fetchPhotos(bannerId) {
    this.setState({ photosLoading: true });
    try {
      const response = await this.engine.getItem(`Banners/${bannerId}/photos`);
      if (response && response.data) {
        this.setState({ photos: response.data.items || [] });
      }
    } catch (err) {
      console.error("Failed to fetch photos", err);
    }
    this.setState({ photosLoading: false });
  }

  handleBannerFileSelect = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.selectedBannerFile = file;
    this.previewUrl = URL.createObjectURL(file);
    // picking a new picture undoes a pending removal
    this.setState({ removeMedia: false });
  };

  // Drops the picture the form is showing: a file picked but not saved yet is
  // just forgotten, while the one already on the banner is only marked here
  // and cleared server-side on Save (removeMedia), like every other field.
  handleRemoveBannerImage = () => {
    if (this.selectedBannerFile) {
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      this.selectedBannerFile = null;
      this.previewUrl = null;
      if (this.bannerFileRef.current) this.bannerFileRef.current.value = "";
      this.forceUpdate();
      return;
    }

    if (!window.confirm(strings.confirmdelete)) return;
    this.setState({ removeMedia: true });
  };

  handlePhotoUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    e.target.value = "";

    const { id } = this.state;
    this.setState({ uploadingPhoto: true });
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await this.engine.postItemMultipart(
        `Banners/${id}/photos`,
        formData
      );
      if (response && (response.status === 200 || response.status === 201)) {
        await this.fetchPhotos(id);
      }
    } catch (err) {
      alert("Failed to upload photo: " + (err.message || "Unknown error"));
    }
    this.setState({ uploadingPhoto: false });
  };

  handleDeletePhoto = async (photoId) => {
    const { id } = this.state;
    if (!window.confirm(strings.confirmdelete || "Delete this photo?")) return;
    try {
      await this.engine.deleteItem(`Banners/${id}/photos`, photoId);
      this.setState((prev) => ({
        photos: prev.photos.filter((p) => p.id !== photoId),
      }));
    } catch (err) {
      alert("Failed to delete photo: " + (err.message || "Unknown error"));
    }
  };

  handleValidSubmit = async () => {
    const { id, title, description, merchantId, branchId, version, removeMedia } =
      this.state;

    if (!id && !this.selectedBannerFile) {
      alert(strings.select + " " + strings.picture);
      return;
    }

    this.setState({ loading: true });

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);

      let response;
      if (id) {
        formData.append("version", String(version));
        if (this.selectedBannerFile) {
          formData.append("file", this.selectedBannerFile);
        } else if (removeMedia) {
          formData.append("removeMedia", "true");
        }
        response = await this.engine.putItemMultipart(
          this.pathname,
          id,
          formData
        );
      } else {
        formData.append("merchantId", merchantId);
        if (branchId) formData.append("branchId", branchId);
        formData.append("file", this.selectedBannerFile);
        response = await this.engine.postItemMultipart(
          this.pathname,
          formData
        );
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push("/admin/" + this.pathname);
      }
    } catch (err) {
      const msg = err.response?.data?.message;
      alert(
        Array.isArray(msg)
          ? msg.join(", ")
          : msg || "An unexpected error occurred"
      );
    }

    this.setState({ loading: false });
  };

  renderBannerImageSection() {
    const { id, currentMediaUrl, removeMedia } = this.state;
    const preview = this.previewUrl
      ? this.previewUrl
      : currentMediaUrl && !removeMedia
      ? Constants.serverlink + currentMediaUrl
      : null;

    return (
      <Row style={{ marginBottom: 16 }}>
        <Col sm="2">
          <label style={{ paddingTop: 8 }}>{strings.picture}</label>
        </Col>
        <Col sm="10">
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            {preview && (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={preview}
                  alt="banner"
                  style={{
                    width: 160,
                    height: 100,
                    objectFit: "cover",
                    borderRadius: 6,
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  title={strings.delete}
                  onClick={this.handleRemoveBannerImage}
                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    background: "rgba(220,53,69,0.85)",
                    border: "none",
                    borderRadius: "50%",
                    color: "#fff",
                    width: 24,
                    height: 24,
                    cursor: "pointer",
                    fontSize: 14,
                    lineHeight: "24px",
                    textAlign: "center",
                    padding: 0,
                  }}
                >
                  &times;
                </button>
              </div>
            )}
            <button
              type="button"
              onClick={() =>
                this.bannerFileRef.current && this.bannerFileRef.current.click()
              }
              style={{
                padding: "8px 20px",
                borderRadius: 6,
                border: "2px dashed #aaa",
                background: "#f8f9fa",
                cursor: "pointer",
                color: "#555",
              }}
            >
              {id ? strings.select || "Change Image" : strings.select || "Select Image"}
            </button>
            <input
              ref={this.bannerFileRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={this.handleBannerFileSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderPhotosSection() {
    const { id, photos, photosLoading, uploadingPhoto } = this.state;
    if (!id) return null;

    return (
      <Card style={{ marginTop: 16 }}>
        <CardHeader>
          <CardTitle tag="h4">{strings.photos || "Photos"}</CardTitle>
        </CardHeader>
        <CardBody>
          {photosLoading ? (
            <p>Loading photos...</p>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
              {photos.map((photo) => (
                <div
                  key={photo.id}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <img
                    src={Constants.serverlink + photo.url}
                    alt="banner"
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => this.handleDeletePhoto(photo.id)}
                    style={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      background: "rgba(220,53,69,0.85)",
                      border: "none",
                      borderRadius: "50%",
                      color: "#fff",
                      width: 24,
                      height: 24,
                      cursor: "pointer",
                      fontSize: 14,
                      lineHeight: "24px",
                      textAlign: "center",
                      padding: 0,
                    }}
                  >
                    &times;
                  </button>
                </div>
              ))}

              <button
                type="button"
                onClick={() =>
                  this.photoFileRef.current && this.photoFileRef.current.click()
                }
                disabled={uploadingPhoto}
                style={{
                  width: 120,
                  height: 120,
                  borderRadius: 6,
                  border: "2px dashed #aaa",
                  background: "#f8f9fa",
                  cursor: uploadingPhoto ? "not-allowed" : "pointer",
                  fontSize: 32,
                  color: "#aaa",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {uploadingPhoto ? "..." : "+"}
              </button>
            </div>
          )}

          <input
            ref={this.photoFileRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={this.handlePhotoUpload}
          />
        </CardBody>
      </Card>
    );
  }

  render() {
    const {
      loading,
      isLoading,
      title,
      description,
      merchantId,
      branchId,
      merchantlist,
      branchlist,
      id,
    } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <h4>{strings.information}</h4>
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={() => this.handleValidSubmit()}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  {!id && (
                    <SelectRow
                      label={strings.merchant}
                      name="merchantId"
                      defaultValue={merchantId}
                      data={merchantlist}
                      changeInput={(e) => {
                        const selectedMerchantId = e.value;
                        this.setState({ merchantId: selectedMerchantId }, () =>
                          this.fetchBranches(selectedMerchantId)
                        );
                      }}
                    />
                  )}
                  {!id && (
                    <SelectRow
                      label={strings.branch}
                      name="branchId"
                      defaultValue={branchId}
                      data={branchlist}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}
                  <FormRow
                    label={strings.title}
                    name="title"
                    data={title}
                    changeInput={this.changeInput.bind(this)}
                  />
                  <FormRow
                    label={strings.description}
                    name="description"
                    data={description}
                    changeInput={this.changeInput}
                  />
                  {this.renderBannerImageSection()}
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>

            {this.renderPhotosSection()}
          </Col>
        </Row>
      </div>
    );
  }
}
